<template>
  <section>
    <Toolbar />
    <div
      class="
        d-flex
        flex-column
        justify-center
        align-center
        mt-xs-5 mt-sm-5 mt-md-3 mt-lg-3 mt-xl-3
        mx-0
      "
    >
      <v-row justify="center" class="ma-0 pa-0">
        <v-col
          cols="11"
          xs="11"
          sm="11"
          md="12"
          lg="12"
          xl="12"
          class="ma-0 pa-0"
        >
          <h2 class="texto-titulo text-center font-weight-bold">
            ¿Cuánto dinero necesitas?
          </h2>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0">
        <v-col cols="9" class="ma-0 mb-0" style="position: relative">
          <v-row justify="center">
            <v-col cols="12" class="d-flex flex-row justify-center">
              <div class="monto-background"></div>
            </v-col>
          </v-row>
          <v-row justify="center" class="ma-0 pa-0">
            <v-col cols="12" class="my-2 pa-0">
              <v-row>
                <v-col cols="12">
                  <v-card class="monto-contenido rounded-xl ma-0 py-1 px-2">
                    <v-card-text class="ma-0 pa-0 text-center">
                      <label
                        for="monto"
                        class="text-caption font-weight-bold"
                        :class="{
                          'orange--text': esMontoSujetoAprobar,
                          'red--text': esMontoInputInvalido,
                          'grey--text text--darken-2':
                            !esMontoInputInvalido && !esMontoSujetoAprobar,
                        }"
                        >{{
                          esMontoInputInvalido || esMontoSujetoAprobar
                            ? montoInputError
                            : ''
                        }}</label
                      ><br />
                      <div
                        class="d-flex flex-row justify-center align-center"
                        @keyup="cambiaMontoInput()"
                      >
                        <v-icon
                          :class="{
                            'red--text': esMontoInputInvalido,
                            'primary--text': !esMontoInputInvalido,
                          }"
                          size="20"
                        >
                          mdi-currency-usd
                        </v-icon>
                        <money
                          :v-focus="moneyInputFocus"
                          v-model="montoInput"
                          v-bind="money"
                          :class="{
                            'red--text': esMontoInputInvalido,
                            'primary--text': !esMontoInputInvalido,
                          }"
                          class="font-weight-bold monto-input"
                        ></money>
                        <v-icon
                          :class="{
                            'red--text': esMontoInputInvalido,
                            'primary--text': !esMontoInputInvalido,
                          }"
                          size="20"
                          @click="focusInputMoney"
                        >
                          mdi-braille
                        </v-icon>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <v-row justify="center">
      <v-col cols="10">
        <v-slider
          v-model="credito.monto.val"
          step="100"
          :min="montoMinimo"
          :max="credito.monto.max"
          track-color="#ccc"
          class="slider-monto"
          hide-details="auto"
          @end="endChange"
        ></v-slider>
        <div class="d-flex flex-row justify-space-between">
          <v-btn x-small text color="grey" @click="seleccionarMontoMinimo"
            >Mínimo<br />{{ montoMoneda(montoMinimo) }}</v-btn
          >
          <v-btn x-small text color="grey" @click="seleccionarMontoMaximo"
            >Máximo<br />{{ montoMoneda(credito.monto.max) }}</v-btn
          >
        </div>
      </v-col>
    </v-row>
    <v-row
      justify="center"
      class="ma-0 pa-0 mt-5 mt-xs-5 mt-sm-5 mt-md-3 mt-lg-3 mt-xl-3"
    >
      <v-col cols="10" class="ma-0 pa-0">
        <ControlFrecuencia
          :label="frecuencia.label"
          :frecuencias="frecuencia.valores"
          v-model="credito.frecuenciaSeleccionada.val"
        />
      </v-col>
    </v-row>
    <v-row
      justify="center"
      class="ma-0 pa-0 mt-7 mt-xs-7 mt-sm-7 mt-md-5 mt-lg-5 mt-xl-5"
    >
      <v-col cols="10" class="ma-0 pa-0">
        <v-select
          v-model="plazoSeleccionado"
          item-text="name"
          item-value="val"
          :items="plazos"
          label="Plazo"
          hide-details="auto"
          outlined
          :loading="cargando"
          :disabled="cargando"
        ></v-select>
      </v-col>
    </v-row>
    <v-row
      justify="center"
      class="ma-0 pa-0 mt-5 mt-xs-5 mt-sm-5 mt-md-3 mt-lg-3 mt-xl-3"
    >
      <v-col cols="10" class="ma-0 pa-0">
        <v-alert
          dense
          text
          type="info"
          :icon="false"
          class="text-center font-weight-black ma-0"
        >
          <template v-if="!cargando">
            Tu pago {{ credito.frecuenciaSeleccionada.val.toLowerCase() }} es
            de: {{ montoMoneda(credito.montoPago.val) }}
          </template>
          <v-progress-circular
            v-else
            indeterminate
            color="info"
            :width="3"
          ></v-progress-circular>
        </v-alert>
      </v-col>
    </v-row>
    <v-row
      justify="center"
      class="ma-0 pa-0 mt-5 mt-xs-5 mt-sm-5 mt-md-3 mt-lg-3 mt-xl-3"
    >
      <v-col cols="10" class="ma-0 pa-0">
        <p class="text-caption text-center font-weight-bold ma-0 pa-0">
          Oferta válida hasta {{ obtenerVigencia }} <br />
          <v-icon
            justify="center"
            class="text-xs-center"
            slot="icon"
            color="error"
            size="20"
            fab
          >
            mdi-sale
          </v-icon>
          Tasa mensual: {{ credito.tasa.val }}%
        </p>

        <!-- <v-row
          justify="center"
          class="ma-0 pa-0 mt-0 mt-xs-0 mt-sm-0 mt-md-0 mt-lg-0 mt-xl-0"
        >
          <v-col cols="2"></v-col>
          <v-col cols="8" class="ma-0 pa-0"> -->
        <div class="d-flex flex-row justify-center mt-2">
          <v-dialog v-model="dialog" width="500">
            <template v-slot:activator="{ on, attrs }">
              <a
                href="#"
                class="align-self-center d-flex flex-row justify-center"
                color="secondary"
                v-bind="attrs"
                v-on="on"
                elevation="3"
                >Comparación de tasas con otros</a
              >
              <!-- <v-btn
                class="align-self-center"
                color="primary"
                v-bind="attrs"
                v-on="on"
                elevation="3"
                @click="noInteresado"
                >NO INTERESADO DE MOMENTO<v-icon right light
                  >mdi-arrow-left</v-icon
                ></v-btn
              > -->
            </template>
            <v-card class="ma-0 pa-0" cols="5">
              <v-card-title>Nuestra tasa frente a otros</v-card-title>
              <v-row>
                <v-col cols="6">
                  <v-card-subtitle></v-card-subtitle>
                </v-col>
                <v-col cols="6">
                  <v-card-subtitle class="text-body text-center mt-2 py-0"
                    >Tasa mensual
                  </v-card-subtitle>
                </v-col>
              </v-row>
              <v-list-item>
                <v-list-item-content>
                  <v-row>
                    <v-col cols="8">
                      <v-subheader
                        v-text="'Valladolid Caja Financiera'"
                        class="px-0 my-0 mt-0 font-weight-bold"
                        style="height: 100%"
                      ></v-subheader>
                    </v-col>
                    <v-col cols="4">
                      <v-list-item-title class="font-weight-bold"
                        >{{ credito.tasa.val }}%</v-list-item-title
                      >
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-divider
                      :inset="true"
                      class="ml-1 mt-0"
                      style="max-width: 100%; !important"
                    ></v-divider>
                  </v-row>
                  <v-row>
                    <v-col cols="8">
                      <v-subheader
                        v-text="'MercadoLibre'"
                        class="px-0 my-0 mt-0"
                        style="height: 100%"
                      ></v-subheader>
                    </v-col>
                    <v-col cols="4">
                      <v-list-item-title> 8.20% </v-list-item-title>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-divider
                      :inset="true"
                      class="ml-1 mt-0"
                      style="max-width: 100%; !important"
                    ></v-divider>
                  </v-row>
                  <v-row>
                    <v-col cols="8">
                      <v-subheader
                        v-text="'Provident'"
                        class="px-0 my-0 mt-0"
                        style="height: 100%"
                      ></v-subheader>
                    </v-col>
                    <v-col cols="4">
                      <v-list-item-title>9.00%</v-list-item-title>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-divider
                      :inset="true"
                      class="ml-1 mt-0"
                      style="max-width: 100%; !important"
                    ></v-divider>
                  </v-row>
                  <v-row class="mb-2">
                    <v-col cols="8">
                      <v-subheader
                        v-text="'Didi prestamos'"
                        class="px-0 my-0 mt-0"
                        style="height: 100%"
                      ></v-subheader>
                    </v-col>
                    <v-col cols="4">
                      <v-list-item-title>9.12%</v-list-item-title>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-dialog>
        </div>
        <!-- </v-col>
          <v-col cols="2"></v-col>
        </v-row> -->

        <p
          class="text-center font-weight-bold ma-0 pa-0 mt-5 subtitle"
          style="color: #8e24aa"
        >
          Paga menos: puedes abonar a capital
        </p>
        <p
          class="text-center font-weight-bold ma-0 pa-0 subtitle"
          style="color: #8e24aa"
        >
          Liquida en cualquier momento sin penalización
        </p>
        <!-- <v-banner
          class="mb-5"
          elevation="5"
          outlined
          rounded
          single-line
          shaped
        >
          <p class="text-center grey--text text--darken-2 ma-0 pa-0">
            Oferta válida por tiempo limitado <br />
          </p>
          <v-icon slot="icon" color="error" size="36"> mdi-sale </v-icon>
          <p class="text-center grey--text text--darken-2 ma-0 pa-0">
            La mejor tasa en créditos digitales: <br />
            {{ credito.tasa.val }}% mensual
          </p>
        </v-banner> -->
      </v-col>
      <v-col v-if="tipoPersona == 2" cols="8" class="ma-0 pa-0 mb-5">
        <br />
        <p class="text-caption text-center grey--text text--darken-2 ma-0 pa-0">
          Recuerda se tomarán $500.00 de tu monto solicitado para ser socio.
        </p>
      </v-col>
    </v-row>
    <v-row justify="center" class="ma-0 pa-0 mt-5">
      <v-col cols="6" class="ma-0 pa-0 d-flex flex-row justify-center">
        <!-- <v-btn
          class="mr-7"
          :loading="cargando"
          :disabled="cargando"
          elevation="2"
          :to="{ name: 'cancelacion' }"
        >
          OBTENER DESPUES
        </v-btn> -->
        <!-- <v-spacer></v-spacer> -->
        <!-- <div style="width: 10%"></div> -->
        <v-btn
          color="primary"
          :disabled="
            esMontoInputInvalido ||
            credito.monto.val < montoMinimo ||
            credito.monto.val > credito.monto.max
          "
          elevation="3"
          @click="submit"
          :loading="cargando"
          >¡Me interesa!<v-icon right light>mdi-arrow-right</v-icon></v-btn
        >
        <!-- </v-col>
      <div style="height: 50px"></div>
      <v-col cols="10" class="ma-0 pa-0 d-flex flex-row justify-center"> -->
        <!-- <div style="width: 10%"></div> -->
      </v-col>
      <!--<v-col cols="3">
         <v-fab-transition>
          <v-btn color="primary" @click="whats" fab large right
            ><v-icon>mdi-whatsapp</v-icon>
          </v-btn>
        </v-fab-transition> 
      </v-col>-->
    </v-row>
    <v-row>
      <!-- <v-col cols="3"></v-col> -->
      <v-col cols="9" class="text-right align-center" style="display: grid"
        >¿Necesitas ayuda? Escribenos</v-col
      >
      <v-col cols="3">
        <v-fab-transition>
          <v-btn color="primary" @click="whats" fab right
            ><v-icon>mdi-whatsapp</v-icon>
          </v-btn>
        </v-fab-transition>
      </v-col>
    </v-row>
    <!-- <v-row>
      <v-col cols="8"></v-col>
      <v-col cols="4"> -->
    <!-- <section>
      <v-fab-transition>
        <v-btn color="primary" @click="whats" fab large right
          ><v-icon>mdi-whatsapp</v-icon>
        </v-btn>
      </v-fab-transition>
    </section> -->
    <!-- </v-col>
    </v-row> -->
    <!-- <v-btn elevation="2" fab right></v-btn> -->
  </section>
</template>

<script>
import Toolbar from '@/components/compartidos/Toolbar.vue'
import ControlFrecuencia from '@/components/compartidos/controles_formulario/ControlFrecuencia.vue'
import Credito from '@/servicios/credito'
import { mapActions, mapGetters } from 'vuex'
import {
  ALERTA_ERROR,
  // ID_PRODUCTO_CREDITO_ACTIVACASH,
  // ID_PROCESO_CREDITO_DIGITAL_CONSUMO,
  ID_PRODUCTO_CREDITO_ENLAZAMAS,
  ID_PRODUCTO_CREDITO_SP,
  ID_PRODUCTO_CREDITO_SPLUS,
  plazosValidos,
} from '@/utilidades/utilidades'
import { FormatoMonedaMixin } from '@/mixins/formateos/FormatoMoneda.mixin'
import { InsertaLogMixin } from '@/mixins/credito/InsertaLog.mixin'
import { Money } from 'v-money'
import OtpService from '@/servicios/otp'
import axios from 'axios'

export default {
  name: 'ParametrizacionCredito',
  mixins: [FormatoMonedaMixin, InsertaLogMixin],
  data: () => ({
    dialog: false,
    moneyInputFocus: false,
    plazoSeleccionado: 0,
    montoMinimo: 5000,
    frecuencia: '',
    plazos: '',
    credito: '',
    montoInput: 0,
    esMontoInputInvalido: false,
    esMontoSujetoAprobar: false,
    money: {
      decimal: '.',
      thousands: ',',
      prefix: '',
      suffix: '',
      precision: 0,
      masked: false,
    },
    montoInputError: '',
    editable: '',
    cargando: false,
    tipoPersona: 1,
    montoPreutorizado: 0,
  }),
  computed: {
    ...mapGetters({
      obtenerPersona: 'persona/obtenerPersona',
      obtenerVigencia: 'credito/obtenerFechaVigencia',
    }),
  },
  components: {
    Toolbar,
    ControlFrecuencia,
    Money,
  },
  mounted() {
    this.InsertaLog()
  },
  created() {
    this.editable = this.$store.getters['credito/obtenerEditable']
    this.credito = this.$store.getters['credito/obtenerCredito']
    // console.log(this.credito)
    this.$store.commit('ESTABLECER_LAYOUT', 'Layout')
    this.frecuencia = this.$store.getters['credito/obtenerFrecuencias']
    if (this.credito.tipoCredito == ID_PRODUCTO_CREDITO_ENLAZAMAS) {
      this.frecuencia.label = 'Tu retención será de manera:'
    }
    if (
      this.credito.tipoCredito == ID_PRODUCTO_CREDITO_SP ||
      this.credito.tipoCredito == ID_PRODUCTO_CREDITO_SPLUS
    ) {
      this.frecuencia.label = 'Tu frecuencia de pago es:'
    }
    this.plazoSeleccionado = this.credito.plazo.val
    this.montoInput = this.credito.monto.val

    if (this.credito.tipoCredito == ID_PRODUCTO_CREDITO_SPLUS) {
      this.plazos = plazosValidos(
        this.montoInput,
        this.$store.getters['credito/obtenerPlazos'],
        this.$store.getters['credito/obtenerRangoMontosPlazos']
      )
    } else {
      this.plazos = this.$store.getters['credito/obtenerPlazos']
    }
    this.tipoPersona = this.$store.getters['persona/obtenerPersona'].tipoPersona
    this.montoPreutorizado = this.credito.monto.val
  },
  methods: {
    focusInputMoney() {
      // Vue.directive('focus', {
      //   inserted: function (el) {
      //     el.focus()
      //   }
      // })
      // this.$refs.moneyInput.focus()
      this.moneyInputFocus = true
    },
    endChange() {
      this.montoInput = this.credito.monto.val
      this.updateMontoPago()
      this.$gtag.event('cambiarMonto', {
        event_category: 'change_in_window',
        event_label: 'Cambia Monto en parametrización',
        value: this.credito.monto.val,
      })
    },
    changeMontoInput() {
      // console.log('avers')
      this.credito.monto.val = this.montoInput
      this.updateMontoPago()
      this.$gtag.event('cambiarMonto', {
        event_category: 'change_in_window',
        event_label: 'Cambia Monto en parametrización',
        value: this.credito.monto.val,
      })
    },
    seleccionarMontoMinimo() {
      this.credito.monto.val = this.montoMinimo
      this.montoInput = this.credito.monto.val
      this.updateMontoPago()
    },
    seleccionarMontoMaximo() {
      this.credito.monto.val = this.credito.monto.max
      this.montoInput = this.credito.monto.val
      this.updateMontoPago()
    },
    updateCredito() {
      this.credito.plazo = {
        mask: this.credito.plazo.mask,
        name: this.plazoSeleccionado + this.credito.plazo.mask,
        title: 'PLAZO',
        val: this.plazoSeleccionado,
      }
      this.plazoSeleccionado
      this.$store.credito = this.credito
      this.$store.dispatch('credito/actualizarCredito', this.credito)
      this.$store.dispatch('credito/actualizarPlazos')
    },
    verificarMontoIngresadoEsValido() {
      if (this.montoInput < this.montoMinimo) {
        return
      } else if (this.montoInput > this.credito.monto.max) {
        return
      } else if (this.montoInput % 100 !== 0) {
        return
      } else {
        this.updateMontoPago()
      }
    },
    async updateMontoPago() {
      let result
      try {
        this.cargando = true
        if (this.credito.tipoCredito == ID_PRODUCTO_CREDITO_SPLUS) {
          this.plazos = plazosValidos(
            this.montoInput,
            this.$store.getters['credito/obtenerPlazos'],
            this.$store.getters['credito/obtenerRangoMontosPlazos']
          )
          const exits = this.plazos.some(
            (plazo) => plazo.val == this.plazoSeleccionado
          )
          if (!exits) {
            this.plazoSeleccionado = this.plazos[this.plazos.length - 1].val
            this.credito.plazo = {
              mask: this.credito.plazo.mask,
              name: this.plazoSeleccionado + this.credito.plazo.mask,
              title: 'PLAZO',
              val: this.plazoSeleccionado,
            }
          }
        }
        result = await Credito.obtenerPagoSimulado(this.credito)
        if (result.data.Codigo == 200) {
          // console.log(result.data)
          this.$store.dispatch(
            'credito/actuliazarMontoPago',
            result.data.Modelo
          )
        } else {
          this.enviarAlertaError(
            result.data.Mensaje,
            ALERTA_ERROR.tiempo,
            ALERTA_ERROR.visible
          )
        }
        this.cargando = false
      } catch (e) {
        if (!axios.isCancel(e)) {
          this.enviarAlertaError(
            ALERTA_ERROR.mensaje,
            ALERTA_ERROR.tiempo,
            ALERTA_ERROR.visible
          )
          this.cargando = false
        }
      }
    },
    submit() {
      this.updateCredito()
      if (this.$store.getters['credito/obtenerEditable']) {
        // if (
        //   // this.$store.getters['credito/obtenerCredito'].tipoCredito ==
        //   // ID_PRODUCTO_CREDITO_ACTIVACASH
        //   this.$store.getters['credito/obtenerCredito'].tipoProcesoCredito ==
        //   ID_PROCESO_CREDITO_DIGITAL_CONSUMO
        // ) {
        //   // this.$router.push('cargaDocumentos')
        //   this.$router.push('datosDomicilio')
        // } else {
        //   this.$router.push('beneficios')
        // }
        this.continuarAVerificacionOtp()
      } else {
        this.$router.push('confirmacion')
      }
    },
    whats() {
      // window.location.href = 'https://wa.me/5215510695948'
      this.InsertaLog({ notas: 'CLICK EN FAB DE WHATSAPP' })
      window.open('https://wa.me/5215510695948', '_blank')
    },
    cambiaMontoInput() {
      this.updateCredito()
      this.updateMontoPago()
    },
    async enviarOtp() {
      this.cargando = true
      const enviarOtpRequest =
        this.$store.getters['persona/obtenerEnviarOtpRequest']
      let result
      try {
        result = await OtpService.EnviarOtp(enviarOtpRequest)
        if (result.data.Codigo != 200 && result.data.Modelo != true) {
          this.enviarAlertaError(
            result.data.Mensaje,
            ALERTA_ERROR.tiempo,
            ALERTA_ERROR.visible
          )
        }
        this.cargando = false
      } catch {
        this.enviarAlertaError(
          result.data.Mensaje,
          ALERTA_ERROR.tiempo,
          ALERTA_ERROR.visible
        )
        this.cargando = false
      }
    },
    async continuarAVerificacionOtp() {
      await this.enviarOtp()
      this.$router.push('verificacion-otp')
    },
    ...mapActions({
      enviarAlertaError: 'alerta/enviarAlertaError',
    }),
  },
  watch: {
    plazoSeleccionado: function () {
      this.updateCredito()
      this.updateMontoPago()
      this.$gtag.event('cambiarPlazo', {
        event_category: 'change_in_window',
        event_label: 'Cambia Plazo',
        value: this.credito.plazoSeleccionado,
      })
    },
    'credito.frecuenciaSeleccionada.val': function (value) {
      this.updateCredito()
      this.$store.dispatch(
        'credito/actualizaDatosFrecuenciaSeleccionada',
        value
      )
      const plazoIndex = this.plazos.findIndex(
        (plazo) => plazo.val == this.plazoSeleccionado
      )
      if (this.credito.tipoCredito == ID_PRODUCTO_CREDITO_SPLUS) {
        this.plazos = plazosValidos(
          this.montoInput,
          this.$store.getters['credito/obtenerPlazos'],
          this.$store.getters['credito/obtenerRangoMontosPlazos']
        )
      } else {
        this.plazos = this.$store.getters['credito/obtenerPlazos']
      }
      if (plazoIndex != -1) {
        if (this.credito.tipoCredito != ID_PRODUCTO_CREDITO_SPLUS) {
          this.plazoSeleccionado = this.plazos[plazoIndex].val
        }
      } else {
        if (this.credito.tipoCredito != ID_PRODUCTO_CREDITO_SPLUS) {
          this.plazoSeleccionado = this.plazos.at(-1).val
        }
      }
      this.$gtag.event('cambiarFrecuencia', {
        event_category: 'change_in_window',
        event_label: 'Cambia Frecuencia',
        value: this.credito.frecuenciaSeleccionada.val,
      })
    },
    // 'credito.monto.val': function (value) {
    montoInput(value) {
      // console.log(value, this.montoPreutorizado)
      // console.log('mnt inpt wtchr', value)
      this.credito.monto.val = value
      if (value < this.montoMinimo) {
        // Verificar que el monto no sea menor que el minimo pemitido
        this.esMontoInputInvalido = true
        this.esMontoSujetoAprobar = false
        this.montoInputError = 'El monto mínimo es de $' + this.montoMinimo
      } else if (value > this.credito.monto.max) {
        // Verificar que el monto no exceda el maximo
        this.esMontoInputInvalido = true
        this.esMontoSujetoAprobar = false
        this.montoInputError =
          'El monto máximo es de $' + this.credito.monto.max
      } else if (value % 100 !== 0) {
        // Verificar que el monto sea multiplo de 100
        this.esMontoInputInvalido = true
        this.esMontoSujetoAprobar = false
        this.montoInputError = 'Elige un monto múltiplo de 100'
      } else if (value > this.montoPreutorizado) {
        this.esMontoSujetoAprobar = true
        this.esMontoInputInvalido = false
        this.montoInputError = 'Monto sujeto a aprobación'
      } else {
        this.esMontoSujetoAprobar = false
        this.esMontoInputInvalido = false
        this.credito.monto.val = this.montoInput
        this.montoInputError = ''
      }
    },
    'this.credito.plazo.val': function () {
      // console.log('lewacherjala')
      this.updateMontoPago()
      this.$gtag.event('cambiarPlazo2', {
        event_category: 'change_in_window',
        event_label: 'Cambia Plazo',
        value: this.credito.plazoSeleccionado,
      })
    },
  },
  filters: {
    formatoMoneda(valor) {
      return valor.toFixed(2).replace(/[^0-9.-]+/g, '')
    },
  },
}
</script>

<style scoped>
.monto-background {
  background-color: #5e9f42 !important;
  height: 80%;
  width: 80%;
  top: 10px;
  justify-self: center;
  position: absolute;
  border-radius: 100%;
}
.monto-wrapper .v-input__control {
  border: 1px solid #e9e9e9;
  box-shadow: 0px 1px 1px #e9e9e9;
}
.monto-contenido {
  width: 300px;
}
.monto-input {
  font-size: 20px;
  width: 90px;
}
.monto-input:focus,
.monto-input:active,
.monto-input:hover {
  outline: none;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
